import { Button } from '@mui/material'
import React from 'react'
import { queryClient } from '../../../../../../App'

const AcceptBtn = ({ currentServiceData, action }) => {
  const handleAccept = () => {
    action(currentServiceData.id).then(() => {
      queryClient.invalidateQueries({ queryKey: ['service-table'] })
    })
  }
  return (
    <Button
      onClick={handleAccept}
      disabled={currentServiceData.status === 2 ? false : true}
      fullWidth
      variant='contained'
    >
      Принять на обслуживание
    </Button>
  )
}

export default AcceptBtn
